import {
  Button,
  Link,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const MfaSetupForm = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  color: theme.customColors.textPrimary,
  gap: theme.spacing(2),
  maxWidth: "350px",
  width: "100%"
}));

export const MfaSetupHeader = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  gap: theme.spacing(1),
  width: "100%"
}));

export const MfaSetupTitle = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "1.5rem",
  fontWeight: 700,
  lineHeight: 1.2,
  textAlign: "center",

  [theme.breakpoints.down("sm")]: {
    fontSize: "1.25rem"
  }
}));

export const MfaSetupDescription = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.875rem",
  lineHeight: 1.25,
  maxWidth: "360px",
  textAlign: "center"
}));

export const MfaSetupQrContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  gap: theme.spacing(1.5),
  width: "100%"
}));

export const MfaSetupQrImage = styled("img")(() => ({
  borderRadius: "10px",
  height: "144px",
  width: "144px"
}));

export const MfaSetupQrLoading = styled(Stack)(() => ({
  alignItems: "center",
  height: "144px",
  justifyContent: "center",
  width: "144px"
}));

export const MfaSetupHint = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem",
  lineHeight: 1.3,
  textAlign: "center"
}));

export const MfaSetupFields = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1.25),
  width: "100%"
}));

export const MfaSetupField = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
  width: "100%"
}));

export const MfaSetupFieldLabel = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textPrimary,
  fontSize: "0.75rem",
  fontWeight: 500,
  lineHeight: 1.2
}));

export const MfaSetupTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: theme.customColors.textPrimary,
    fontSize: "0.875rem"
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: theme.customColors.textPrimary,
    WebkitTextFillColor: theme.customColors.textPrimary
  },
  "& .MuiInputBase-input::placeholder": {
    color: theme.customColors.textDisabledAlternative,
    opacity: 1
  },
  "& .MuiOutlinedInput-input": {
    padding: "10px 12px"
  },
  "& .MuiOutlinedInput-root": {
    backgroundColor: theme.customColors.backgroundPrimary,
    borderRadius: "7px"
  },
  "& .MuiOutlinedInput-root fieldset": {
    borderColor: theme.customColors.border
  },
  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
    borderColor: theme.customColors.borderPrimaryCta
  },
  "& .MuiOutlinedInput-root:hover fieldset": {
    borderColor: theme.customColors.borderAccent
  },
  "& fieldset": {
    top: 0
  },
  "& legend": {
    display: "none"
  }
}));

export const MfaSetupConfirmButton = styled(Button)(({ theme }) => ({
  "&:disabled": {
    backgroundColor: theme.customColors.backgroundDisabledAlternative,
    color: theme.customColors.textDisabled
  },
  "&:hover": {
    backgroundColor: theme.customColors.backgroundPrimaryCtaHover
  },
  backgroundColor: theme.customColors.backgroundPrimaryCta,
  borderRadius: "7px",
  color: theme.customColors.textPrimaryCta,
  fontSize: "0.875rem",
  fontWeight: 700,
  height: "42px",
  textTransform: "none",
  width: "100%"
}));

export const MfaSetupSupport = styled(Link)(({ theme }) => ({
  "&:hover": {
    color: theme.customColors.backgroundPrimaryCtaHover
  },
  color: theme.customColors.backgroundPrimaryCta,
  fontSize: "0.75rem",
  fontWeight: 700,
  lineHeight: 1.2,
  textDecoration: "none"
}));
